import { Button } from '@/components/button';
import { FormLabel } from '@/components/form/formlabel';
import { Input } from '@/components/form/input';
import {
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/form/select';
import { Modal } from '@/components/modal';
import { clearErrors } from '@/reducers/auth';
import { AppDispatch } from '@/root/store';
import { FormatCurrency } from '@/routes/root';
import { UpdateAdminFee } from '@/services/events';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import { DocumentCheckIcon, PencilIcon } from '@heroicons/react/24/solid';
import { Select } from '@radix-ui/react-select';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { DashboardCard } from '../../../dashboard/_card';
import { SectionItem, SectionTabs } from '../../../_nav/section';

const sections: Record<string, string> = {
  committee: 'Daftar panitia',
  permit: 'Surat Izin',
};

export function OrgEventSettingLayout() {
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();

  const pathArray = location.pathname.split('/').slice(2);
  const section = pathArray[2];

  const [adminModal, setAdminModal] = useState(false);
  const [formData, setFormData] = useState({
    amount: 0,
    type: '',
    assigned_type: '',
  });

  const { event, errors } = useSelector((state: any) => state.event);

  const setData = (value: string, element: string) => {
    setFormData({ ...formData, [element]: value });

    dispatch(clearErrors());
  };

  const submit = () => {
    dispatch(UpdateAdminFee(event.id, formData));
    setAdminModal(false);
  };

  useEffect(() => {
    if (event) {
      setFormData({
        ...formData,
        type: event.settings?.fees?.type,
        assigned_type: event.settings?.fees?.assigned_type,
        amount: event.settings?.fees?.amount,
      });
    }
  }, [event]);

  return !section ? (
    <Navigate to='committee' />
  ) : (
    <>
      <Modal
        show={adminModal}
        onRequestClose={() => setAdminModal(false)}
        width='medium'
        title='Ubah Biaya Admin'
        body={
          <div className='flex flex-col gap-4'>
            <FormLabel
              label='Tipe Biaya Admin'
              errorText={errors.type}
              required
            >
              <Select
                defaultValue={formData.type}
                onValueChange={(e) => setData(e, 'type')}
              >
                <SelectTrigger>
                  <SelectValue defaultValue='nominal' />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value={'nominal'}>Nominal</SelectItem>
                    <SelectItem value={'percent'}>Persentase</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </FormLabel>
            <FormLabel
              label='Target Biaya Admin'
              errorText={errors.assigned_type}
              required
            >
              <Select
                defaultValue={formData.assigned_type}
                onValueChange={(e) => setData(e, 'assigned_type')}
              >
                <SelectTrigger>
                  <SelectValue defaultValue='full-org' />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value={'full-org'}>Full Organizer</SelectItem>
                    <SelectItem value={'full-guest'}>Full Guest</SelectItem>
                    <SelectItem value={'fifty-fifty'}>Fifty Fifty</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </FormLabel>
            <FormLabel label='Biaya Admin' errorText={errors.amount} required>
              <Input
                leftDeco='Rp'
                type='price'
                value={formData.amount}
                onChange={(e) => setData(e.target.value, 'amount')}
                required
              />
            </FormLabel>
          </div>
        }
        footer={
          <div className='flex justify-end gap-3'>
            <Button
              variant='neutral'
              onClick={() => setAdminModal(false)}
              leftIcon={<NoSymbolIcon />}
            >
              Batal
            </Button>
            <Button onClick={submit} leftIcon={<DocumentCheckIcon />}>
              Simpan
            </Button>
          </div>
        }
      />
      <div className='flex gap-6'>
        <DashboardCard
          variant='whiteAlt'
          name='Biaya Admin'
          topLabel={{
            primary:
              formData.type === 'nominal' ? (
                <FormatCurrency amount={formData.amount} />
              ) : (
                `${formData.amount}%`
              ),
            secondary: formData.assigned_type,
          }}
          bottomLabel={{
            primary: (
              <>
                {event?.logged_in_organizer?.role === 'superadmin' && (
                  <Button
                    variant={'neutral'}
                    size='sm'
                    leftIcon={<PencilIcon />}
                    onClick={() => setAdminModal(true)}
                  >
                    Ubah Biaya Admin
                  </Button>
                )}
              </>
            ),
          }}
          className='w-[268px]'
        />
      </div>
      <SectionTabs grow={false}>
        {Object.entries(sections).map(([key, value]) => {
          return (
            <SectionItem
              id={key}
              key={key}
              name={value}
              isCurrent={section === key}
            />
          );
        })}
      </SectionTabs>
      <Outlet />
    </>
  );
}
